import React, { useState } from 'react';
import Box from '@mui/material/Box';
import { SubGroupWrapper } from 'src/components/profileComponents/Marketplace/components/SubGroupWrapper';
import {
  useStyles as mainUseStyles,
} from 'src/components/profileComponents/Marketplace/components/UnitsTiles/components/Common/styles';
import {
  UploadMarketplace,
} from 'src/components/profileComponents/Marketplace/components/Filters/components/UploadMarketplace';
import {
  UnitCardProperty,
} from 'src/components/profileComponents/Marketplace/components/UnitsTiles/components/Common/components/UnitCardProperty';
import { IMarketplacePlacementProperty, Option } from 'src/components/profileComponents/Marketplace/types';
import { IMarketplacePlacementCardFirstHeaderMainElementBase } from 'src/typings/marketplaceTile';
import { readURL } from 'src/helpers';

interface Props<T> {
  title: string;
  entity: T,
  onChange: (entity: T) => void,
  lang: string,
  propertyOptions: Option<IMarketplacePlacementProperty>[],
  moveToTrash: () => void
}

export const UnitsCardHeaderEntity = <T extends IMarketplacePlacementCardFirstHeaderMainElementBase, >({
  title, entity, onChange, lang, propertyOptions, moveToTrash,
}: Props<T>) => {
  const [image, setImage] = useState<string | null>(entity.iconFileUri?.fileUrl || null);
  const mainStyles = mainUseStyles();
  return (
    <SubGroupWrapper
      name={title}
      onTrash={() => moveToTrash()}
      customOffsetStyles={mainStyles.customOffsetStyles}
    >
      <Box display="flex" flexDirection="column" flex="auto">
        <Box display="flex" gap="20px">
          <UnitCardProperty<any>
            entity={entity}
            onChange={onChange}
            lang={lang}
            propertyOptions={propertyOptions}
          />
          <UploadMarketplace
            register={() => {}}
            registerName=""
            image={image}
            onUpload={async (file, response) => {
              onChange({ ...entity, iconFileUri: response.data[0] });
              const base64: string = await readURL(file);
              if (base64) {
                setImage(base64);
              }
            }}
            onMoveToTrash={() => {
              onChange({ ...entity, iconFileUri: null });
              setImage(null);
            }}
          />
        </Box>
      </Box>
    </SubGroupWrapper>
  );
};
